<!-- <ng-template>
    <ngx-skeleton-loader *ngIf="isLoading" count="5" [theme]="{ width: '200px', height: '200px' }"></ngx-skeleton-loader>
</ng-template>	 -->
<div class="card-header d-flex justify-content-between align-items-center">
    <h4 class="card-title">{{ 'ACTION_REMEDIATION' | translate}}</h4>
    <a href="/user/action-plan" class="ml-25">{{ 'DISPLAY_ALL' | translate }}</a>
</div>
<div class="table-responsive">
    <table class="table">
        <thead>
        <tr>
            <th class="col-8">{{ 'TITLE' | translate }}</th>
            <th>{{ 'PRIORITY' | translate }}</th>
            <th>{{ 'COST' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data">
            <td><span (click)="modalOpen(modalLG, item.action_id)"
                      class="cursor-pointer">{{ item.action.name | apiTranslate }}</span></td>
            <ng-template #modalLG let-modal>
                <div *ngIf="!modalLoading">
                    <div class="modal-header">
                        <h4>{{modalData.name | apiTranslate}}</h4>
                        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body collapse-icon">
                        <ul ngbNav #nav="ngbNav" class="nav-tabs">
                            <li ngbNavItem>
                                <a ngbNavLink>Général</a>
                                <ng-template ngbNavContent>
                                    <div class="col-md">
                                        <div [innerHTML]="modalData.description | apiTranslate | sanitizeHTML"></div>
                                    </div>
                                    <hr>
                                    <div class="col-md">
                                        <div *ngIf="modalData.question[0]?.name?.fr">
                                            <h5>Action liée à la question :</h5>
                                            <div>{{ modalData.question[0]?.name?.fr }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            <li ngbNavItem *ngIf="modalData.risk">
                                <a ngbNavLink>Risques</a>
                                <ng-template ngbNavContent>
                                    <div class="col-md">
                                        <div [innerHTML]="modalData.risk | apiTranslate | sanitizeHTML"></div>
                                    </div>
                                </ng-template>
                            </li>
                            <li ngbNavItem *ngIf="modalData.impact">
                                <a ngbNavLink>Impact</a>
                                <ng-template ngbNavContent>
                                    <div class="col-md">
                                        <div [innerHTML]="modalData.impact | apiTranslate | sanitizeHTML"></div>
                                    </div>
                                </ng-template>
                            </li>
                            <li ngbNavItem *ngIf="modalData.implementation">
                                <a ngbNavLink>Remédiation</a>
                                <ng-template ngbNavContent>
                                    <div class="col-md">
                                        <div [innerHTML]="modalData.implementation | apiTranslate | sanitizeHTML"></div>
                                    </div>
                                </ng-template>
                            </li>
                            <li ngbNavItem *ngIf="modalData.product[0]">
                                <a ngbNavLink>Les outils</a>
                                <ng-template ngbNavContent>
                                            <ngb-accordion [destroyOnHide]="false" [closeOthers]="true"
                                                           activeIds="ngb-panel-0">
                                                <ngb-panel id="ngb-panel-{{tool.id}}"
                                                           *ngFor="let tool of modalData?.product">
                                                    <ng-template ngbPanelTitle>
                                                        <span class="lead collapse-title">{{ tool.name }}</span>
                                                    </ng-template>
                                                    <ng-template ngbPanelContent>
                                                        <div *ngIf="!tool.opensource" class="badge badge-light-warning">Licence commerciale</div>
                                                        <div *ngIf="tool.opensource" class="badge badge-light-success">Open source</div>
                                                        <div class="card-body">
                                                            <dl class="row">
                                                                <dt class="col-sm-3">Editeur</dt>
                                                                <dd class="col-sm-9">{{ tool.manufacturer.name }}
                                                                </dd>
                                                            </dl>
                                                            <dl class="row">
                                                                <dt class="col-sm-3">Description</dt>
                                                                <dd class="col-sm-9"><div [innerHTML]="tool.detail | sanitizeHTML"></div>
                                                                </dd>
                                                            </dl>
                                                        </div>
                                                        <button class="btn btn-outline-secondary float-right m-1"
                                                                (click)="openDetailHelp(tool.url_documentation)">
                                                            Plus d'infos
                                                        </button>
                                                    </ng-template>
                                                </ngb-panel>
                                            </ngb-accordion>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="nav" class="mt-2"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')"
                                rippleEffect>
                            Compris
                            <span data-feather="check">
											</span>
                        </button>
                    </div>
                </div>
            </ng-template>
            <td>
                <span class="badge badge-pill"
                        [ngClass]="{
                        'badge-light-success': item.action.important == '1',
                        'badge-light-warning': item.action.important == '2',
                        'badge-light-danger': item.action.important == '3'
                    }">{{ "ACTION_PLAN.LABELS.IMPORTANCE." + labels.importances[item.action.important - 1] | translate }}
                </span>
            </td>
            <td>{{ labels.prices[item.action.pricing - 1] }}</td>
        </tr>
        </tbody>
    </table>
</div>
